import Vue from 'vue';
// import Antd from 'ant-design-vue/es';
import {
  Button,
  Col,
  Row,
  Form,
  Icon,
  Input,
  InputNumber,
  message,
  Modal,
  notification,
  Select,
  ConfigProvider,
  Alert,
  Spin,
  DatePicker,
  TimePicker,
  Tooltip,
  Menu,
  Pagination,
  Dropdown,
  Upload,
  Table,
  Steps,
  Empty,
  Timeline,
  Progress,
  Divider,
  Checkbox,
  Tabs,
  Radio,
  Switch,
  FormModel,
  Tree,
  Transfer,
  TreeSelect,
  Tag,
  Popover,
  Popconfirm,
  Badge,
  Carousel,
} from 'ant-design-vue';
Vue.use(Button);
Vue.use(Col);
Vue.use(Row);
Vue.use(Form);
Vue.use(Icon);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(ConfigProvider);
Vue.use(Alert);
Vue.use(Spin);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Tooltip);
Vue.use(Menu);
Vue.use(Pagination);
Vue.use(Dropdown);
Vue.use(Upload);
Vue.use(Table);
Vue.use(Steps);
Vue.use(Empty);
Vue.use(Timeline);
Vue.use(Progress);
Vue.use(Divider);
Vue.use(Modal);
Vue.use(Checkbox);
Vue.use(Tabs);
Vue.use(Radio);
Vue.use(Switch);
Vue.use(FormModel);
Vue.use(Tree);
Vue.use(Transfer);
Vue.use(TreeSelect);
Vue.use(Tag);
Vue.use(Popover);
Vue.use(Popconfirm);
Vue.use(Badge);
Vue.use(Carousel);

Vue.prototype.$message = message;
window.$message = message;
Vue.prototype.$notification = notification;
window.$notification = notification;
Vue.prototype.$confirm = Modal.confirm;
window.$confirm = Modal.confirm;

Vue.prototype.$info = Modal.info;
window.$info = Modal.info;

Vue.prototype.$warning = Modal.warning;
window.$warning = Modal.warning;

Vue.prototype.$success = Modal.success;
window.$success = Modal.success;

Vue.prototype.$error = Modal.error;
window.$error = Modal.error;

// Vue.use(Antd);

// message全局配置
message.config({
  top: '12px',
  // 悬浮5秒
  duration: 5,
  // 最多提示1个报错
  maxCount: 1,
});

// 通知框全局设置
notification.config({
  placement: 'topRight',
  duration: 5,
  top: '10px',
});
